import { render, staticRenderFns } from "./c_shop_header.vue?vue&type=template&id=4cb80a71&scoped=true"
import script from "./c_shop_header.vue?vue&type=script&lang=js"
export * from "./c_shop_header.vue?vue&type=script&lang=js"
import style0 from "./c_shop_header.vue?vue&type=style&index=0&id=4cb80a71&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb80a71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb80a71')) {
      api.createRecord('4cb80a71', component.options)
    } else {
      api.reload('4cb80a71', component.options)
    }
    module.hot.accept("./c_shop_header.vue?vue&type=template&id=4cb80a71&scoped=true", function () {
      api.rerender('4cb80a71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_shop_header.vue"
export default component.exports